export default __webpack_public_path__ + "static/media/tigerbox_touch_purple.7325746e.png";